import React from 'react';

import ConfigMobileIdentity from './ConfigMobileIdentity';
import Config from './components/ClientConfig';


export default function ConfigWebsiteIdentity(props) {
  return (
    <ConfigMobileIdentity
      {...props}
      identityLabel="Website Identity"
      textApiUrl={Config.API_URL_CONFIG_WEBSITE_TEXT}
      textAddApiUrl={Config.API_URL_CONFIG_WEBSITE_TEXT_ADD}
      textResponseKey="WebsiteTextConfigs"
      imageApiUrl={Config.API_URL_CONFIG_WEBSITE_IMAGE}
      imageAddApiUrl={Config.API_URL_CONFIG_WEBSITE_IMAGE_ADD}
      imageResponseKey="WebsiteImageConfigs"
      refreshLocalConfig={false}
    />
  );
}
